// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"EN-z","upvoteIcon":"FN-z","downvoteIcon":"GN-z","feedbackIcon":"HN-z"};